/**************************/
/* JSContext data getters */
/**************************/

var _ = require('underscore');

var utils = require('./utils');
var dateUtils = require('./datetime-helpers');
var contextData = (typeof(window) !== 'undefined' && window.JSContext) || {};


// Used to load alternative data into JSContext (i.e. sample data)
var loadData = function(data) {
    contextData = data;
};

var _get = function(key) {
    return contextData[key];
};

var _formatPosts = function(posts, dateFormat) {
    return _.map(posts, function(post) {
        if (post.link) {
            post.link = utils.makeAbsolute(post.link);
        }
        if(post.publish_date) {
            post.formattedPublishDate = dateUtils.formatDate(post.publish_date, dateFormat);
        }
        return post;
    });
};

var _formatSingleEvent = function(dateFormat, dateEndFormat) {
    dateEndFormat = dateEndFormat || "h:mm a";
    return function(evt) {
        evt.formattedDate = dateUtils.formatDate(evt.event_date, dateFormat);
        if(evt.event_date_end) {
            evt.formattedDateEnd = dateUtils.formatDate(evt.event_date_end, dateEndFormat);
        }
        evt.formattedDateRange = dateUtils.formatEventDates(evt.event_date, evt.event_date_end, dateFormat);
        switch(evt.rsvp_type){
            case("email"):
                evt.rsvp_link = "mailto:" + evt.rsvp_info;
                break;
            case("link"):
                evt.rsvp_link = utils.makeAbsolute(evt.rsvp_info);
                break;
            case("phone"):
                evt.rsvp_link = "tel:" + utils.stripNonDigits(evt.rsvp_info);
                break;
            default:
                break;
        }
        return evt;
    };
};

var _formatEvents = function(events, dateFormat, dateEndFormat) {
    return _.map(events, _formatSingleEvent(dateFormat, dateEndFormat));
};

var getProfile = function() {
    return _get("profile");
};

var getThemeData = function() {
    return _get("theme_data");
};

var getLocatorLink = function() {
    return _get("locator_link");
};

var getOrgLink = function() {
    return _get("org_link");
};

var getBaseLink = function() {
    return _get("base_link");
};

var getSlug = function() {
    return _get("slug");
};

var getRequestId = function() {
    return _get("request_id");
};

var getPosts = function(options) {
    if(_.isNumber(options)) {
        // Make this backwards compatible due to a code freeze
        options = { maxPosts: options };
    }
    options = options || {};

    var posts = _get("posts");
    if(posts) {
        posts = posts.slice(0, options.maxPosts);
    }
    posts = _formatPosts(posts, options.dateFormat);
    return posts;
};

var getEvent = function(eventId, options) {
    options = options || {};
    var evt = _.find(_get("events"), function(evt) {
        return evt.id.toString() === eventId;
    });
    return evt && _formatSingleEvent(options.dateFormat, options.dateEndFormat)(evt);
};

var getEvents = function(options) {
    if(_.isNumber(options)) {
        // Make this backwards compatible due to a code freeze
        options = { maxEvents: options };
    }
    options = options || {};

    var events = _get("events");
    if(events) {
        events = events.slice(0, options.maxEvents);
    }
    events = _formatEvents(events, options.dateFormat, options.dateEndFormat);
    return events;
};

var getCategories = function() {
    return _get("categories");
};

var getCategoryMap = function() {
    return _get("category_map");
};

var getStatusCode = function() {
    return _get("status_code");
};

var getStatusMessage = function() {
    return _get("status_message");
};

var getGoogleMapsKey = function() {
    return _get("google_maps_key");
};

var getKalturaPartnerId = function(){
    return _get("kaltura_partner_id");
};

var getKalturaDefaultUiconf = function(){
    return _get("kaltura_default_uiconf");
};

var getKalturaServiceUrl = function(){
    return _get("kaltura_service_url");
};

var getKalturaVideosQueue = function() {
    return _get("kalturaVideosQueue");
};

var setKalturaVideosQueue = function(value) {
    contextData.kalturaVideosQueue = value;
};

var isKalturaLoaded = function() {
    return Boolean(_get("kalturaLoaded"));
};

var setKalturaLoaded = function(value) {
    contextData.kalturaLoaded = value;
};

var getTagCategories = function() {
    return _get("TagCategories");
};

var useNewSearch = function() {
    return Boolean(_get("USE_NEW_SEARCH"));
};

exports.loadData = loadData;
exports.getProfile = getProfile;
exports.getThemeData = getThemeData;
exports.getLocatorLink = getLocatorLink;
exports.getOrgLink = getOrgLink;
exports.getBaseLink = getBaseLink;
exports.getSlug = getSlug;
exports.getRequestId = getRequestId;
exports.getPosts = getPosts;
exports.getEvents = getEvents;
exports.getEvent = getEvent;
exports.getCategories = getCategories;
exports.getCategoryMap = getCategoryMap;
exports.getStatusCode = getStatusCode;
exports.getStatusMessage = getStatusMessage;
exports.getGoogleMapsKey = getGoogleMapsKey;
exports.getKalturaPartnerId = getKalturaPartnerId;
exports.getKalturaDefaultUiconf = getKalturaDefaultUiconf;
exports.getKalturaServiceUrl = getKalturaServiceUrl;
exports.getKalturaVideosQueue = getKalturaVideosQueue;
exports.setKalturaVideosQueue = setKalturaVideosQueue;
exports.isKalturaLoaded = isKalturaLoaded;
exports.setKalturaLoaded = setKalturaLoaded;
exports.getTagCategories = getTagCategories;
exports.useNewSearch = useNewSearch;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/poly-js-utils/src/jscontext.js
// module id = 190
// module chunks = 8